import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid  } from '@material-ui/core';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, DatePickerComponent, TextFieldWithSelectComponent} from '../../components/FormElement';
import Button from '../../components/ButtonCustom';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import {PersonAddIcon} from '../../components/icons'

    const styles = theme => ({
        container:{
            padding: theme.spacing(6)
        },

        form:{
            backgroundColor: theme.palette.background.box,
            padding: theme.spacing(8,4,8,4),
            borderRadius: theme.spacing(2),
            
        },
        button: {
            marginTop: theme.spacing(8),
            padding: theme.spacing(1)
        },

        icon_bg: {
            width: 56,
            height: 56,
            borderRadius: 56,
            backgroundColor: theme.palette.background.card,
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
            padding: theme.spacing(0,0,0,3)
        },
    
    });

function TermAndConditions(props) {

    const onRegister = (values) =>{
        let itemToBeJoin = props.itemToBeJoin;
        if (itemToBeJoin.sign_up_option == 'CLOSE_LOOP_SIGN_UP') {
            itemToBeJoin.email_address = values.email;
           
        }
        else{
            itemToBeJoin.email_address = "";
        }
        props.onRegister(itemToBeJoin);
    }

    const {classes, t, onClose, itemToBeJoin } = props
    //console.log(' this.props.open====',this.props.open)
    return (
        <div>
            <DrawerCustom open={props.open} onClose={props.onClose} 
                children={<DrawerItem classes={classes} t={t}
                                onRegister={onRegister}
                                onClose = {onClose}
                                itemToBeJoin = {itemToBeJoin}
                                />}/>
    </div>
    );
}
function DrawerItem(props) {
    const { t, classes, onRegister, onClose, itemToBeJoin} = props;
    return (

         <Grid item className={classes.container}>
             <Grid xs={12}>
		 		<CustomTypo variant='caption1' light>{t('join_a_scheme')}</CustomTypo>
             </Grid>

             <Grid xs ={12} item container  justify='center' >
                 <Grid item container className={classes.icon_bg} justify='center' alignItems='center'>
                    <PersonAddIcon />
                 </Grid>
             </Grid>
             <Grid xs ={12} item container justify='center'>
                <CustomTypo mg_top_xl light>{t('Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren…')}</CustomTypo>
             </Grid>
             <Grid xs={12}>
		 		<CustomTypo variant='caption1' light>{itemToBeJoin&&itemToBeJoin.description?itemToBeJoin.description:""}</CustomTypo>
             </Grid>
                         <Form
                             onSubmit={onRegister}
                             render={({ handleSubmit}) => (
                                 <Grid xs={12} container item  justify='center' className={classes.form}>
                                     {itemToBeJoin&&itemToBeJoin.sign_up_option&&itemToBeJoin.sign_up_option == 'CLOSE_LOOP_SIGN_UP' &&<Grid xs={12} item container>
                                         <Field
                                             name="email"
                                             component={TextFieldComponent}
                                             //label={t('first_name')}
                                            placeholder={t('email_input_placeholder')}
                                             isEdit={true}
                                            color='primary'
                                             //validate={validators.composeValidators(validators.validEmail)}
                                             //onChange={(text) => this.props.onHandleChange('first_name', text)}
                                         />
                                     </Grid>}
                                    
                                     <Grid xs={12} item container justify='center' >
                                        <Grid xs={6} item className={classes.button}>
                                            <Button color='onPrimary' fullWidth onClick={()=>onClose()} id="btn_term_condition_cancel">{t('btn_cancel')}</Button>
                                        </Grid>
                                        <Grid xs={6} item className={classes.button}> 
                                            <Button color='primary' fullWidth onClick={handleSubmit} id="btn_term_condition_sign_up">{t('Sign Up')}</Button>
                                        </Grid>
                                     </Grid>
                                 </Grid>
             )} />
         </Grid>
    )
}
export default withStyles(styles)(withTranslation()(TermAndConditions));